import React from 'react';
import OverviewDashboard from '@components/overview-dashboard';
import { ContentWrapper } from '../styled';

function Content({ currentShareId, pageType }) {
  return (
    <ContentWrapper>
      <OverviewDashboard currentShareId={currentShareId} pageType={pageType} />
    </ContentWrapper>
  );
}

export default Content;
